import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { getConsent, setConsent, loadGA } from "@/lib/analytics";

const COPY = {
  ro: {
    eyebrow: "[ COOKIES ]",
    body: "Folosim cookie-uri de analytics (Google Analytics 4) pentru a înțelege cum este utilizat site-ul și a-l îmbunătăți. Poți accepta sau refuza — alegerea ta se salvează local.",
    accept: "Accept",
    decline: "Refuz",
  },
  en: {
    eyebrow: "[ COOKIES ]",
    body: "We use analytics cookies (Google Analytics 4) to understand how the site is used and to improve it. You can accept or decline — your choice is saved locally.",
    accept: "Accept",
    decline: "Decline",
  },
};

export default function CookieBanner() {
  const { lang } = useLang();
  const c = COPY[lang] || COPY.ro;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Never surface on the admin CMS.
    if (window.location.pathname.startsWith("/admin")) return;
    const consent = getConsent();
    if (consent === "accepted") loadGA();
    else if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    setConsent("accepted");
    loadGA();
    setVisible(false);
  };

  const decline = () => {
    setConsent("declined");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          exit={{ y: "110%" }}
          transition={{ duration: 0.55, ease: [0.16, 1, 0.3, 1] }}
          className="fixed inset-x-0 bottom-0 z-[70] bg-ink text-paper border-t border-paper/15"
        >
          <div className="max-w-6xl mx-auto px-6 md:px-12 py-5 flex flex-col md:flex-row md:items-center gap-5 md:gap-10">
            <p className="text-sm leading-relaxed flex-1 text-paper/85">
              <span className="eyebrow text-paper mr-2">{c.eyebrow}</span>
              {c.body}
            </p>
            <div className="flex gap-3 shrink-0">
              <button
                type="button"
                onClick={accept}
                data-testid="cookie-accept"
                className="eyebrow bg-paper text-ink px-7 py-3 hover:opacity-80 transition-opacity"
              >
                {c.accept}
              </button>
              <button
                type="button"
                onClick={decline}
                data-testid="cookie-decline"
                className="eyebrow border border-paper/40 px-7 py-3 hover:bg-paper hover:text-ink transition-colors"
              >
                {c.decline}
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
